import { SocketStatus } from "../../../../shared/config";
export var selectSocket = function selectSocket(state) {
  return state.socket;
};
export var selectReconnectCount = function selectReconnectCount(state) {
  return selectSocket(state).reconnectCount;
};
export var selectSocketStatus = function selectSocketStatus(state) {
  return selectSocket(state).socketStatus;
};
export var selectIsSocketReady = function selectIsSocketReady(state) {
  return selectSocketStatus(state) === SocketStatus.open;
};